export default "__VITE_ASSET__BGbxdmkR__"